import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
const avatarTones = ['bg-coral-wash text-coral-deep', 'bg-gold-wash text-gold-deep', 'bg-leaf-wash text-leaf-deep', 'bg-navy/10 text-navy'];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="bg-paper" data-id="element-345" data-mp="3azt57ofmmxjh">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-346" data-mp="36ziphk218srf">
        <SectionHeading id="testimonials-title" title="Des chrétiens choisissent une façon plus simple de commencer à partager leur foi" data-id="element-347" data-mp="31zwap66k34gi" />
        <ul className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-348" data-mp="2x1upaelnqt1v">
          {testimonials.map((t, i) => <li key={t.name} className="flex flex-col rounded-2xl bg-white p-7 shadow-card ring-1 ring-cream-line sm:p-8" data-id="element-349" data-mp="2s2rvjqb4o997" data-mpi={i}>
              <QuoteIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-350" data-mp="v8ndhf596tkq" />
              <p className="mt-4 font-display text-2xl leading-tight text-navy" data-id="element-351" data-mp="qbeujcca6lif">« {t.headline} »</p>
              <blockquote className="mt-3 flex-1 leading-relaxed text-ink-soft" data-id="element-352" data-mp="h4wyecfigumy">« {t.quote} »</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-cream-line pt-5" data-id="element-353" data-mp="m5swuah3fokz">
                <span className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-xl ${avatarTones[i % avatarTones.length]}`} data-id="element-354" data-mp="7928cw8yjxa5">
                  {t.name.charAt(0)}
                </span>
                <div data-id="element-355" data-mp="zwy0rorhv314">
                  <p className="font-extrabold text-navy" data-id="element-356" data-mp="zyiu5b22ofxe">{t.name}</p>
                  <p className="text-sm text-ink-mute" data-id="element-357" data-mp="14u7rd7qmdkqj">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}